import { BaseLinkButton, Body, H3, PrimaryArrowButton } from '@rikstv/shared-components';
import { useNavigate } from 'react-router-dom';
import { trackClickInternetCTA } from '~/analytics/eventTracker';
import { captureUXEvent } from '~/analytics/productAnalytics';
import rtvLogo from '~/assets/images/rikstv-logo.svg?url';
import { Card } from '~/components/shared';
import { FlexBox } from '~/components/shared/layout/FlexBox';
import { useIsMobileView } from '~/hooks/useMediaQuery';
import { FCC } from '~/utils/types';
import { campaignRoutes } from '../../campaign/campaign.routes';
import { useLazySanityData } from '../hooks/useLazySanityData';
import { ReactComponent as NgtLogoSvg } from '../icons/ngt-logo.svg';

export const TvPackageOnlyCard = ({ noInternetPackages }: { noInternetPackages?: boolean }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobileView();
  const {
    displayData: { tvOnlyTitle, tvOnlyDescription },
  } = useLazySanityData();
  const btnLabel = 'Se våre TV-pakker';
  const onClick = () => {
    trackClickInternetCTA({ link_text: btnLabel, ngt_available: true, link_url: location.origin + campaignRoutes.index });
            navigate(campaignRoutes.index);
  }
  
  const outerFlexAlign = !noInternetPackages ? "center" : undefined;
  const outerFlexDirection = isMobile ? "column" : undefined;
  const innerFlexAlign = !noInternetPackages && isMobile ? 'center' : 'flex-start';
  return (
    <GridWrapper noInternetPackages={noInternetPackages}>
      <Card noMargin>
        <FlexBox wrap={false} alignItems={outerFlexAlign} direction={outerFlexDirection}>
          <FlexBox direction="column" gap={24} style={{ flex: 1 }} alignItems={innerFlexAlign}>
            <div>
              <img src={rtvLogo} height={25} alt="RiksTV logo" />
            </div>
            <H3>{tvOnlyTitle}</H3>
            <Body as='div' style={{minHeight: 'calc(1em * 3'}}>{tvOnlyDescription}</Body>
            {noInternetPackages && <PrimaryArrowButton onClick={onClick}>{btnLabel}</PrimaryArrowButton>}
          </FlexBox>
          {!noInternetPackages && (
            <BaseLinkButton element={'button'} buttonStyle={"highlighted"} withArrow onClick={onClick}>{btnLabel}</BaseLinkButton>
          )}
        </FlexBox>
      </Card>
      {noInternetPackages && <NgtInternetCard />}
    </GridWrapper>
  );
};

const GridWrapper: FCC<{noInternetPackages?: boolean}> = ({noInternetPackages, children}) => {
  if (noInternetPackages) {
    return <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: 'calc(24px + var(--rds-fluid-spacing--0-24))' }}>{children}</div>
  }
  return <>{children}</>
}

const NgtInternetCard = () => (
  <Card noMargin>
    <FlexBox direction="column" gap={24} alignItems='flex-start'>
      <NgtLogoSvg height={25} />
      <H3>Ønsker du trådløst bredbånd?</H3>
      <Body as='div'>Sjekk om du kan bestille trådløst bredbånd på NextGenTel sine nettsider. </Body>
      <BaseLinkButton onClick={() => captureUXEvent('rtv_sales_click_ngt_external')} style={{paddingBlock: '16px 4px'}} element={'a'} target="_blank" href="https://www.nextgentel.no/produkter/tradlost-bredband" buttonStyle={"highlighted"} withArrow>Til NextGenTel</BaseLinkButton>
    </FlexBox>
  </Card>
)